import { render } from "./Docs.vue?vue&type=template&id=634bb6f3&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=634bb6f3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-634bb6f3"

export default script